module.exports = new __parcel__URL__("open-hihat_5.14edd338.mp3").toString();